import {combineReducers} from 'redux'
import types from '../../actions/types'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_POST_CONTACT_DIALOG:
      return true
    case types.HIDE_POST_CONTACT_DIALOG:
      return false
    default:
      return state
  }
}

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.EMAILING_CONTACT_POST_ATTEMPT:
      return true
    case types.EMAILING_CONTACT_POST_SUCCESS:
      return false
    case types.EMAILING_CONTACT_POST_FAILURE:
      return false
    case types.HUBSPOT_LOAD_CONTACT_PROPERTIES_ATTEMPT:
      return true
    case types.HUBSPOT_LOAD_CONTACT_PROPERTIES_SUCCESS:
      return false
    case types.HUBSPOT_LOAD_CONTACT_PROPERTIES_FAILURE:
      return false
    default:
      return state
  }
}

export const contact = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_POST_CONTACT_DIALOG:
      return action.contact
    case types.HIDE_POST_CONTACT_DIALOG:
      return null
    default:
      return state
  }
}

export const emailingIntegration = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_POST_CONTACT_DIALOG:
      return action.emailingIntegration
    case types.HIDE_POST_CONTACT_DIALOG:
      return null
    default:
      return state
  }
}

export const isContactPosted = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_POST_CONTACT_DIALOG:
      return false
    case types.HIDE_POST_CONTACT_DIALOG:
      return false
    case types.EMAILING_CONTACT_POST_ATTEMPT:
      return false
    case types.EMAILING_CONTACT_POST_SUCCESS:
      return true
    case types.EMAILING_CONTACT_POST_FAILURE:
      return false
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  isLoading,
  contact,
  emailingIntegration,
  isContactPosted,
})
